import { render, staticRenderFns } from "./Profile2.vue?vue&type=template&id=ebe25d5a&scoped=true"
import script from "./Profile2.vue?vue&type=script&lang=js"
export * from "./Profile2.vue?vue&type=script&lang=js"
import style0 from "./Profile2.vue?vue&type=style&index=0&id=ebe25d5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe25d5a",
  null
  
)

export default component.exports